import * as React from "react";
import { SVGProps } from "react";
const SvgFloorPlan = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 30a1 1 0 0 1-1-1V19a1 1 0 0 1 1-1h5v2H3v8h14v-8h-5v-2h10v2h-3v8h10v-8h-3v-2h3V4H19v9a1 1 0 0 1-1 1h-6v-2h5V4H3v8h4v2H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h28a1 1 0 0 1 1 1v26a1 1 0 0 1-1 1H2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFloorPlan;
